/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from '../../utils/location/googleMapsLoader';
import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { RiEqualizer2Line, RiMapPinLine, RiNotification3Line } from 'react-icons/ri';
import NearbyDrawer from './component/home/nearbyDrawer';
import FilterDrawer from './component/home/filterDrawer';
import CheckIn from './component/home/checkIn';
import CheckOut from './component/home/checkOut';
import CheckOutComplete from './component/home/checkOutComplete';
import FooterHome from './footerHome';
import Splash from './auth/splash';
import LocationPermissionModal from './LocationPermissionModal';
import useLocation from '../../utils/location/location';
import ApiFunction from '../../utils/api/apiFuntions';
import { useSelector, useDispatch } from 'react-redux';
import { decryptData } from '../../utils/api/encrypted';
import { setCheckInStatus, setCheckInData } from '../redux/appDataSlice';
import VisibilityDrawer from './component/home/visibilityDrawer';
import { RiArrowRightSLine, RiCloseLine } from '@remixicon/react';
import { Offcanvas } from 'react-bootstrap';
import CheckInManage from './component/home/checkInManage';
import { Link } from 'react-router-dom';
import { Avatar } from '../icons/icons';
import { formatTitleCompany } from '../../utils/formatTitleCompany';




const isCheckInActive = () => {
  try {
    const checkInData = JSON.parse(localStorage.getItem('checkInData') || '{}');
    const checkInTime = checkInData.checkInTime;
    const duration = checkInData.duration;

    if (!checkInTime || !duration) return false;

    const checkInDate = new Date(checkInTime);
    const expiryDate = new Date(checkInDate.getTime() + (duration * 60 * 1000));
    const now = new Date();

    return now <= expiryDate;
  } catch (error) {
    console.error('Error checking check-in status:', error);
    return false;
  }
};

const clearExpiredCheckIn = () => {
  if (!isCheckInActive()) {
    localStorage.removeItem('checkInLong');
    localStorage.removeItem('checkInLat');
    localStorage.removeItem('checkInType');
    localStorage.removeItem('checkInPlaceName');
    localStorage.removeItem('checkInData');
    return true;
  }
  return false;
};

// Stacked Users Modal Component
const StackedUsersModal = ({ show, users, onClose, onUserSelect }) => {
  if (!show) return null;

  return (
    <Offcanvas backdropClassName="blurred-backdrop-offcanvas" show={show} placement='bottom' onHide={onClose} className="offcanvas-bottom offcanvasBG">
      <Offcanvas.Header className='relative py-4'>
        <h1 className='britti fs_18 mb-0 text-center w-full'>All Hangers ({users?.length})</h1>
        <RiCloseLine onClick={onClose} className='w-[24px] h-[24px] absolute right-5' />
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className='flex flex-col items-center h-100 w-full px-[5px]'>
          {users?.map((user, index) => (
            <div
              key={user.id || index}
              onClick={() => !user.isCurrentUser && onUserSelect(user)}
              className={`profileCard mt-2 flex items-center gap-3 w-full ${!user.isCurrentUser ? 'cursor-pointer' : ''}`}>
              <div className='profile_Image'>
                <img src={user?.image || Avatar} className='bg_primary' alt="" onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = Avatar; }} />
              </div>
              <div>
                <h2 className='fs_16 britti_medium mb-1'>
                  {user?.name} {user.isCurrentUser && '(You)'}
                </h2>
                {formatTitleCompany(user?.designation, user?.company) ? (
                  <span className='fs_14 txt_grey'>{formatTitleCompany(user?.designation, user?.company)}</span>
                ) : null}
              </div>
              {!user.isCurrentUser && <RiArrowRightSLine className='ms-auto w-[20px] h-[20px]' />}
            </div>
          ))}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

const Home = () => {
  const dispatch = useDispatch();
  const {
    location,
    loading: locationLoading,
    error: locationError,
    permissionDenied,
    permissionStatus,
    getCurrentLocation,
    retryLocation
  } = useLocation();

  const [users, setUsers] = useState(null);
  const [isUsersLoading, setIsUsersLoading] = useState(false);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [map, setMap] = useState(null);
  const [userIcons, setUserIcons] = useState({});
  const [currentUserIcon, setCurrentUserIcon] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [currentAddress, setCurrentAddress] = useState('Getting location...');
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [useDefaultLocation, setUseDefaultLocation] = useState(false);
  const [forceRefreshGroups, setForceRefreshGroups] = useState(0);

  // Navigation states
  const [initialNavigationComplete, setInitialNavigationComplete] = useState(false);
  const [isNavigatingToCheckIn, setIsNavigatingToCheckIn] = useState(false);
  const [isAtCheckInLocation, setIsAtCheckInLocation] = useState(false);
  const [showUserAtCurrentLocation, setShowUserAtCurrentLocation] = useState(false);

  // Stacked users states
  const [groupedUsers, setGroupedUsers] = useState([]);
  const [stackedUsersModal, setStackedUsersModal] = useState({
    show: false,
    users: []
  });

  const UserDataEncrypted = useSelector(state => state?.appData?.userData);
  const currentUserData = decryptData(UserDataEncrypted);
  const reduxCheckIn = useSelector(state => state?.appData?.checkInData);
  const [center, setCenter] = useState({
    lat: 20.673,
    lng: -103.344
  });

  // Drawer states
  const [peopleDrawer, setPeopleDrawer] = useState(false);
  const handlePeopleClose = () => setPeopleDrawer(false);

  const [filterDrawer, setFilterDrawer] = useState(false);
  const handleFilterClose = () => setFilterDrawer(false);
  const handleFilterShow = () => setFilterDrawer(true);

  const [checkInDrawer, setCheckInDrawer] = useState(false);
  const [isReplacingCheckIn, setIsReplacingCheckIn] = useState(false);
  const handleCheckInClose = () => {
    setCheckInDrawer(false);
    setIsReplacingCheckIn(false);
  };
  const handleCheckInShow = (replacing = false) => {
    setIsReplacingCheckIn(replacing);
    setCheckInDrawer(true);
  };

  const [checkOutDrawer, setCheckOutDrawer] = useState(false);
  const handleCheckOutClose = () => setCheckOutDrawer(false);
  const handleCheckOutShow = () => setCheckOutDrawer(true);

  const [checkInStatusDrawer, setCheckInStatusDrawer] = useState(false);
  const handleCheckInStatusClose = () => setCheckInStatusDrawer(false);
  const handleCheckInStatusShow = () => setCheckInStatusDrawer(true);

  const [checkoutComplete, setCheckoutComplete] = useState(false);
  const [lastCheckoutPlace, setLastCheckoutPlace] = useState('');
  const handleCompleteCheckoutClose = () => setCheckoutComplete(false);
  const handleCompleteCheckOutShow = (placeName = '') => {
    setLastCheckoutPlace(placeName || '');
    setCheckoutComplete(true);
    // Force refresh groups after checkout
    setForceRefreshGroups(prev => prev + 1);
  };

  const encryptedToken = useSelector(state => state?.appData?.userToken);
  const userToken = decryptData(encryptedToken);


  // Resolve brand CSS vars for map markers (SVG/canvas can't use var() in data URLs)
  const markerToken = (name, fallback) => {
    if (typeof window === 'undefined') return fallback;
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  };
  const MARKER = {
    avatar: () => markerToken('--avatar', '#ACCBFF'),
    border: () => markerToken('--marker-border', '#E5E5E5'),
    fallback: () => markerToken('--marker-fallback', '#83CAE1'),
    countBg: () => markerToken('--marker-count-bg', '#F2F4F7'),
    countText: () => markerToken('--marker-count-text', '#475467'),
    primary: () => markerToken('--primary', '#4A8DFF'),
    white: () => markerToken('--white', '#fff'),
  };

  // Helper function to check if two coordinates are same (within small threshold)
  const areCoordinatesSame = (lat1, lng1, lat2, lng2) => {
    const threshold = 0.0005; // ~11 meters
    const latDiff = Math.abs(parseFloat(lat1) - parseFloat(lat2));
    const lngDiff = Math.abs(parseFloat(lng1) - parseFloat(lng2));
    return latDiff < threshold && lngDiff < threshold;
  };

  // Utility functions for check-in management
  const AvatarSVG = `
<svg width="175" height="175" viewBox="0 0 175 175" fill="none" xmlns="http://www.w3.org/2000/svg">
<defs>
<filter id="defaultMarkerShadow" x="-40%" y="-40%" width="180%" height="180%">
  <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
  <feOffset dx="0" dy="2" result="offsetblur"/>
  <feComponentTransfer>
    <feFuncA type="linear" slope="0.18"/>
  </feComponentTransfer>
  <feMerge>
    <feMergeNode/>
    <feMergeNode in="SourceGraphic"/>
  </feMerge>
</filter>
<clipPath id="clip0_614_4922">
<rect x="10" y="10" width="155" height="155" rx="77.5" fill="white"/>
</clipPath>
</defs>
<circle cx="87.5" cy="87.5" r="82.34375" fill="${MARKER.white()}" filter="url(#defaultMarkerShadow)"/>
<path d="M87.5 5.15625C132.977 5.15625 169.844 42.0228 169.844 87.5C169.844 132.977 132.977 169.844 87.5 169.844C42.0228 169.844 5.15625 132.977 5.15625 87.5C5.15625 42.0228 42.0228 5.15625 87.5 5.15625Z" fill="${MARKER.avatar()}"/>
<path d="M87.5 5.15625C132.977 5.15625 169.844 42.0228 169.844 87.5C169.844 132.977 132.977 169.844 87.5 169.844C42.0228 169.844 5.15625 132.977 5.15625 87.5C5.15625 42.0228 42.0228 5.15625 87.5 5.15625Z" stroke="${MARKER.white()}" stroke-width="9.6875"/>
<g clip-path="url(#clip0_614_4922)">
<ellipse cx="87.501" cy="161.125" rx="62" ry="46.5" fill="white" fill-opacity="0.72"/>
<circle opacity="0.9" cx="87.5005" cy="72" r="31" fill="white"/>
</g>
</svg>`;

  const checkInLat = localStorage?.getItem('checkInLat');
  const checkInLong = localStorage?.getItem('checkInLong');


  useEffect(() => {
    
getCurrentLocation();
getMapUsers();

  }, [checkInLat, checkInLong]); // Depend on these two

  // Single Google Maps loader (Places included) — key from env with existing fallback
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  // Get current location only once on mount
  useEffect(() => {
    getCurrentLocation();
    
  }, []);

  const [showNotification, setShowNotification] = useState(0);
  const { post } = ApiFunction();

  // Stable reference for post function
  const postRef = useRef(post);
  useEffect(() => {
    postRef.current = post;
  }, [post]);

  // ✅ Fixed Notification API
  useEffect(() => {
    if (!userToken) return;

    const getNotificationStatus = async () => {
      const notificationData = new FormData();
      notificationData.append('type', 'get_data');
      notificationData.append('user_id', userToken);
      notificationData.append('table_name', 'notifications');

      try {
        const res = await post('', notificationData);
        if (res?.data && res?.data[0]) {
          setShowNotification(Number(res.data[0].has_unseen));
        }
      } catch (err) {
        console.log("Notification error:", err);
      }
    }

    getNotificationStatus();

    const interval = setInterval(() => {
      getNotificationStatus();
    }, 10000);

    return () => clearInterval(interval);
  }, [userToken]);

  // Handle location permission denied
  useEffect(() => {
    if (permissionDenied && !useDefaultLocation) {
      setShowLocationModal(true);
    }
  }, [permissionDenied, useDefaultLocation]);

  // MAIN LOGIC: Handle initial navigation on login/app load
  useEffect(() => {
    const handleInitialNavigation = async () => {
      if (!userToken || !isLoaded || initialNavigationComplete) return;

      const checkInLat = localStorage.getItem('checkInLat');
      const checkInLong = localStorage.getItem('checkInLong');
      const storedCheckInData = localStorage.getItem('checkInData');

      let isActiveCheckIn = false;
      if (storedCheckInData) {
        try {
          const checkInData = JSON.parse(storedCheckInData);
          const checkInTime = checkInData.checkInTime;
          const duration = checkInData.duration;

          if (checkInTime && duration) {
            const checkInDate = new Date(checkInTime);
            const expiryDate = new Date(checkInDate.getTime() + (duration * 60 * 1000));
            const now = new Date();
            isActiveCheckIn = now <= expiryDate;

            if (!isActiveCheckIn) {
              localStorage.removeItem('checkInLong');
              localStorage.removeItem('checkInLat');
              localStorage.removeItem('checkInType');
              localStorage.removeItem('checkInPlaceName');
              localStorage.removeItem('checkInData');
              dispatch(setCheckInStatus(false));
              dispatch(setCheckInData(null));
            } else {
              dispatch(setCheckInStatus(true));
              dispatch(setCheckInData(checkInData));
            }
          }
        } catch (error) {
          console.error('Error parsing check-in data:', error);
          clearExpiredCheckIn();
        }
      }

      if (isActiveCheckIn && checkInLat && checkInLong) {
        const checkInLatitude = parseFloat(checkInLat);
        const checkInLongitude = parseFloat(checkInLong);
        setLatitude(checkInLatitude);
        setLongitude(checkInLongitude);

        const checkInCenter = {
          lat: checkInLatitude,
          lng: checkInLongitude
        };

        setCenter(checkInCenter);
        setIsAtCheckInLocation(true);
        setShowUserAtCurrentLocation(false);
        if (!setAddressFromCheckInPlace()) {
          getAddressFromCoordinates(checkInLatitude, checkInLongitude);
        }

        if (map) {
          setIsNavigatingToCheckIn(true);
          map.panTo(checkInCenter);
          map.setZoom(16);

          setTimeout(() => {
            setIsNavigatingToCheckIn(false);
          }, 1000);
        }
      } else {
        if (location?.latitude && location?.longitude) {
          setLatitude(location.latitude);
          setLongitude(location.longitude);

          const gpsCenter = {
            lat: location.latitude,
            lng: location.longitude
          };

          setCenter(gpsCenter);
          setIsAtCheckInLocation(false);
          setShowUserAtCurrentLocation(false);
          getAddressFromCoordinates(location.latitude, location.longitude);

          if (map) {
            map.panTo(gpsCenter);
            map.setZoom(14);
          }
        }
      }

      setInitialNavigationComplete(true);
    };

    const timeoutId = setTimeout(handleInitialNavigation, 500);
    return () => clearTimeout(timeoutId);
  }, [userToken, isLoaded, map, location, initialNavigationComplete, dispatch]);

  // Handle check-in status changes
  const checkInStatus = useSelector(state => state.appData?.checkInStatus);

  useEffect(() => {
    if (!initialNavigationComplete) return;

    const checkInLat = localStorage.getItem('checkInLat');
    const checkInLong = localStorage.getItem('checkInLong');

    if (checkInStatus && checkInLat && checkInLong) {
      const checkInLatitude = parseFloat(checkInLat);
      const checkInLongitude = parseFloat(checkInLong);

      setLatitude(checkInLatitude);
      setLongitude(checkInLongitude);
      setShowUserAtCurrentLocation(false);

      const checkInCenter = {
        lat: checkInLatitude,
        lng: checkInLongitude
      };

      if (map) {
        setIsNavigatingToCheckIn(true);
        map.panTo(checkInCenter);
        map.setZoom(16);

        setTimeout(() => {
          setIsNavigatingToCheckIn(false);
        }, 1000);
      } else {
        setCenter(checkInCenter);
      }

      setIsAtCheckInLocation(true);
      if (!setAddressFromCheckInPlace()) {
        getAddressFromCoordinates(checkInLatitude, checkInLongitude);
      }

      // Force refresh groups + re-fetch map users so self/nearby avatars appear after check-in
      setForceRefreshGroups(prev => prev + 1);
      getMapUsers();
    } else if (location?.latitude && location?.longitude) {
      setLatitude(location?.latitude);
      setLongitude(location?.longitude);

      const gpsCenter = {
        lat: location?.latitude,
        lng: location?.longitude
      };

      if (map && !checkInStatus) {
        map.panTo(gpsCenter);
        map.setZoom(14);
      } else if (!checkInStatus) {
        setCenter(gpsCenter);
      }

      setIsAtCheckInLocation(false);
      if (!checkInStatus) {
        getAddressFromCoordinates(location?.latitude, location?.longitude);
      }
    }
  }, [checkInStatus, location, map, initialNavigationComplete]);

  // Auto-clear expired check-ins
  useEffect(() => {
    const checkExpiry = setInterval(() => {
      if (clearExpiredCheckIn()) {
        dispatch(setCheckInStatus(false));
        dispatch(setCheckInData(null));
        setForceRefreshGroups(prev => prev + 1);
      }
    }, 60000);

    return () => clearInterval(checkExpiry);
  }, [dispatch]);

  // Navigation functions
  const navigateToCurrentLocation = useCallback(() => {
    if (!map || !location?.latitude || !location?.longitude) return;

    const gpsCenter = {
      lat: location.latitude,
      lng: location.longitude
    };

    map.panTo(gpsCenter);
    map.setZoom(14);

    setLatitude(location.latitude);
    setLongitude(location.longitude);
    setCenter(gpsCenter);
    setShowUserAtCurrentLocation(true);
    setIsAtCheckInLocation(false);
    getAddressFromCoordinates(location.latitude, location.longitude);
  }, [map, location]);

  const navigateToCheckInFromTimer = useCallback(() => {
    const checkInLat = localStorage.getItem('checkInLat');
    const checkInLong = localStorage.getItem('checkInLong');

    if (checkInStatus && checkInLat && checkInLong && map) {
      const checkInCenter = {
        lat: parseFloat(checkInLat),
        lng: parseFloat(checkInLong)
      };

      setIsNavigatingToCheckIn(true);
      map.panTo(checkInCenter);
      map.setZoom(16);

      setShowUserAtCurrentLocation(false);
      setLatitude(parseFloat(checkInLat));
      setLongitude(parseFloat(checkInLong));
      if (!setAddressFromCheckInPlace()) {
        getAddressFromCoordinates(parseFloat(checkInLat), parseFloat(checkInLong));
      }

      setTimeout(() => {
        setIsNavigatingToCheckIn(false);
      }, 1000);
    }
  }, [checkInStatus, map]);

  // Calculate map center
  const mapCenter = useMemo(() => {
    const checkInLat = localStorage.getItem('checkInLat');
    const checkInLong = localStorage.getItem('checkInLong');

    if (checkInStatus && checkInLat && checkInLong && !showUserAtCurrentLocation) {
      return {
        lat: parseFloat(checkInLat),
        lng: parseFloat(checkInLong)
      };
    }

    return center;
  }, [checkInStatus, center, showUserAtCurrentLocation]);

  // Helper function to validate coordinates
  const isValidCoordinate = (lat, lng) => {
    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);
    return !isNaN(latitude) && !isNaN(longitude) &&
      latitude >= -90 && latitude <= 90 &&
      longitude >= -180 && longitude <= 180;
  };

  // GROUP USERS BY LOCATION - FIXED: Always include other users, conditionally add current user
  const groupUsersByLocation = useCallback((usersList) => {
    if (!usersList || usersList.length === 0) return [];

    // Check if current user is checked in
    const checkInLat = localStorage.getItem('checkInLat');
    const checkInLong = localStorage.getItem('checkInLong');
    const storedCheckInStatus = localStorage.getItem('checkInData');
    let isUserCheckedIn = false;

    if (storedCheckInStatus && checkInLat && checkInLong) {
      try {
        const checkInData = JSON.parse(storedCheckInStatus);
        const checkInTime = checkInData.checkInTime;
        const duration = checkInData.duration;

        if (checkInTime && duration) {
          const checkInDate = new Date(checkInTime);
          const expiryDate = new Date(checkInDate.getTime() + (duration * 60 * 1000));
          const now = new Date();
          isUserCheckedIn = now <= expiryDate;
        }
      } catch (error) {
        console.error('Error parsing check-in data:', error);
      }
    }

    // Start with all other users
    let allUsers = [...usersList];

    // Only add current user if checked in
    if (isUserCheckedIn && currentUserData) {
      allUsers.push({
        id: currentUserData.id || 'current-user',
        name: currentUserData.name || 'You',
        image: currentUserData.image,
        designation: currentUserData.designation,
        company: currentUserData.company,
        isCurrentUser: true,
        loc: {
          lat: checkInLat,
          lng: checkInLong
        }
      });
    }

    const groups = [];
    const processed = new Set();

    allUsers?.forEach((user, index) => {
      if (processed.has(index)) return;

      const userLat = parseFloat(user?.loc?.lat);
      const userLng = parseFloat(user?.loc?.lng);

      if (!isValidCoordinate(userLat, userLng)) return;

      const nearbyUsers = allUsers.filter((otherUser, otherIndex) => {
        if (processed.has(otherIndex)) return false;

        const otherLat = parseFloat(otherUser?.loc?.lat);
        const otherLng = parseFloat(otherUser?.loc?.lng);

        if (!isValidCoordinate(otherLat, otherLng)) return false;

        const distance = Math.sqrt(
          Math.pow(userLat - otherLat, 2) + Math.pow(userLng - otherLng, 2)
        );

        return distance < 0.0005;
      });

      nearbyUsers.forEach((_, idx) => {
        const originalIndex = allUsers.findIndex(u => u.id === nearbyUsers[idx].id);
        processed.add(originalIndex);
      });

      groups.push({
        id: `group-${user.id}`,
        lat: userLat,
        lng: userLng,
        users: nearbyUsers,
        count: nearbyUsers.length
      });
    });

    return groups;
  }, [currentUserData]);

  const createDefaultUserIcon = useCallback(() => {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(AvatarSVG);
  }, []);

  // STACKED MARKER ICON - Clean pill design like reference images
  const createStackedMarkerIcon = useCallback(async (users) => {
    try {
      const maxDisplay = 3;
      const displayUsers = users.slice(0, maxDisplay);
      const remainingCount = users.length - maxDisplay;

      const imagePromises = displayUsers?.map(async user => {
        if (user?.image) {
          try {
            return await convertImageToDataURL(user?.image);
          } catch (error) {
            // CORS canvas fail — embed absolute image URL (LinkedIn) in SVG marker
            return user.image;
          }
        } else {
          return createDefaultUserIcon();
        }
      });

      const imageDataUrls = await Promise.all(imagePromises);

      // Clean dimensions matching reference design
      const avatarSize = 55;
      const borderWidth = 2.5;
      const overlapOffset = 37; // Half overlap for clean look
      const countBubbleSize = remainingCount > 0 ? 44 : 0;

      // Calculate pill dimensions
      const contentWidth = avatarSize + (displayUsers.length - 1) * overlapOffset + countBubbleSize;
      const paddingH = 8;
      const paddingV = 8;

      const pillWidth = contentWidth + (paddingH * 2);
      const pillHeight = avatarSize + (borderWidth * 2) + (paddingV * 2);

      let svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="${pillWidth}" height="${pillHeight}" viewBox="0 0 ${pillWidth} ${pillHeight}">
  <defs>
    <filter id="pillShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
      <feOffset dx="0" dy="2" result="offsetblur"/>
      <feComponentTransfer>
        <feFuncA type="linear" slope="0.15"/>
      </feComponentTransfer>
      <feMerge>
        <feMergeNode/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </defs>
  
  <!-- White pill background -->
  <rect x="3" y="3" width="${pillWidth - 6}" height="${pillHeight - 6}"
        rx="${(pillHeight - 6) / 2}" 
        fill="${MARKER.white()}" 
        filter="url(#pillShadow)" />
`;

      // Add avatars in reverse order (so first user appears on top)
      [...displayUsers].reverse().forEach((user, reverseIndex) => {
        const index = displayUsers.length - 1 - reverseIndex;
        const imageDataUrl = imageDataUrls[index];

        const x = paddingH + index * overlapOffset;
        const y = paddingV;
        const centerX = x + avatarSize / 2;
        const centerY = y + avatarSize / 2 + borderWidth;
        const clipId = `clip-${index}-${Math.random().toString(36).substr(2, 9)}`;

        svg += `
  <g>
    <!-- White ring -->
    <circle cx="${centerX}" cy="${centerY}" r="${(avatarSize / 2) + borderWidth}" 
            fill="${MARKER.white()}" />
    
    <!-- Clip path for circular avatar -->
    <clipPath id="${clipId}">
      <circle cx="${centerX}" cy="${centerY}" r="${avatarSize / 2}" />
    </clipPath>
    
    <!-- Avatar image -->
    <image 
      href="${imageDataUrl}" 
      x="${x}" 
      y="${y + borderWidth}" 
      width="${avatarSize}" 
      height="${avatarSize}"
      clip-path="url(#${clipId})" 
      preserveAspectRatio="xMidYMid slice" />
  </g>
`;
      });

      // Add count bubble if needed
      if (remainingCount > 0) {
        const x = paddingH + displayUsers.length * overlapOffset;
        const y = paddingV;
        const centerX = x + avatarSize / 2;
        const centerY = y + avatarSize / 2 + borderWidth;

        svg += `
  <g>
    <!-- White ring for count -->
    <circle cx="${centerX}" cy="${centerY}" r="${(avatarSize / 2) + borderWidth}" 
            fill="${MARKER.white()}" />
    
    <!-- Gray background -->
    <circle cx="${centerX}" cy="${centerY}" r="${avatarSize / 2}" 
            fill="${MARKER.countBg()}" />
    
    <!-- Count text -->
    <text 
      x="${centerX}" 
      y="${centerY + 1}" 
      text-anchor="middle" 
      dominant-baseline="central"
      font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
      font-size="16" 
      font-weight="600" 
      fill="${MARKER.countText()}">
      +${remainingCount}
    </text>
  </g>
`;
      }

      svg += `</svg>`;

      return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);

    } catch (error) {
      console.error('Error creating stacked marker:', error);
      return null;
    }
  }, [createDefaultUserIcon]);

  // Group users - FIXED to trigger on forceRefreshGroups
  useEffect(() => {
    if (users && users.length > 0) {
      const grouped = groupUsersByLocation(users);
      setGroupedUsers(prevGrouped => {
        const prevString = JSON.stringify(prevGrouped);
        const newString = JSON.stringify(grouped);
        if (prevString !== newString) {
          return grouped;
        }
        return prevGrouped;
      });
    } else {
      setGroupedUsers([]);
    }
  }, [users, forceRefreshGroups]);

  // Load icons for grouped users
  useEffect(() => {
    let isMounted = true;

    const loadGroupedIcons = async () => {
      if (!groupedUsers || groupedUsers.length === 0) {
        if (isMounted) {
          setUserIcons({});
        }
        return;
      }

      const icons = {};

      for (const group of groupedUsers) {
        if (!isMounted) break;

        try {
          const stackedIcon = await createStackedMarkerIcon(group.users);
          if (stackedIcon && isMounted) {
            icons[group.id] = stackedIcon;
          }
        } catch (error) {
          console.error(`Error loading icon for group ${group.id}:`, error);
        }
      }

      if (isMounted) {
        setUserIcons(prevIcons => {
          const prevString = JSON.stringify(prevIcons);
          const newString = JSON.stringify(icons);
          if (prevString !== newString) {
            return icons;
          }
          return prevIcons;
        });
      }
    };

    loadGroupedIcons();

    return () => {
      isMounted = false;
    };
  }, [groupedUsers.length, forceRefreshGroups, createStackedMarkerIcon]);

  // Load current user icon — never null when checked in (default avatar if image miss/CORS fail)
  useEffect(() => {
    const loadCurrentUserIcon = async () => {
      const profileImage = currentUserData?.image;
      if (profileImage) {
        try {
          const borderedIcon = await createMarkerWithBorder(profileImage);
          setCurrentUserIcon(borderedIcon || createDefaultUserIcon());
          return;
        } catch (error) {
          console.error('Error loading current user icon:', error);
          // Prefer remote URL over skipping self marker
          setCurrentUserIcon(profileImage || createDefaultUserIcon());
          return;
        }
      }
      setCurrentUserIcon(createDefaultUserIcon());
    };

    loadCurrentUserIcon();
  }, [currentUserData?.image, createDefaultUserIcon]);

  // Handle stacked marker click
  const handleStackedMarkerClick = useCallback((group) => {
    if (group.count === 1) {
      setSelectedUser(group.users[0]);
      setPeopleDrawer(true);
    } else {
      setStackedUsersModal({
        show: true,
        users: group.users
      });
    }
  }, []);

  // User select from modal
  const handleUserSelectFromModal = useCallback((user) => {
    setStackedUsersModal({ show: false, users: [] });
    setSelectedUser(user);
    setPeopleDrawer(true);
  }, []);

  // Close modal
  const handleCloseStackedModal = useCallback(() => {
    setStackedUsersModal({ show: false, users: [] });
  }, []);


  // Prefer stored check-in place_name over reverse-geocode for map header consistency with chat
  const setAddressFromCheckInPlace = () => {
    const name =
      reduxCheckIn?.place_name ||
      reduxCheckIn?.location?.name ||
      localStorage.getItem('checkInPlaceName') ||
      '';
    if (name) {
      setCurrentAddress(name);
      return true;
    }
    return false;
  };

  // Get address from coordinates
  const getAddressFromCoordinates = async (lat, lng) => {
    try {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const address = results[0].formatted_address;
          setCurrentAddress(address);
        } else {
          setCurrentAddress(`${lat?.toFixed(4)}, ${lng?.toFixed(4)}`);
        }
      });
    } catch (error) {
      console.error('Error getting address:', error);
      setCurrentAddress(`${lat?.toFixed(4)}, ${lng?.toFixed(4)}`);
    }
  };

  // Handle location retry
  const handleLocationRetry = async () => {
    const success = await retryLocation();
    if (!success && permissionStatus === 'denied') {
      // Permission blocked
    }
  };

  useEffect(() => {
    if (permissionStatus === 'granted' && showLocationModal) {
      setShowLocationModal(false);
      getCurrentLocation();
    }
  }, [permissionStatus, showLocationModal, getCurrentLocation]);

  // Handle using app without location
  const handleUseWithoutLocation = () => {
    setShowLocationModal(false);
    setUseDefaultLocation(true);
    setCurrentAddress('Default Location (Enable location for better experience)');
  };

  // Static container style
  const containerStyle = {
    width: '100%',
    height: 'calc(var(--vh, 1vh) * 100)'
  };

  const intervalRef = useRef(null);

  // API call function - use postRef for stable reference
  const getMapUsers = useCallback(async () => {
    if (!userToken) return;

    setIsUsersLoading(true);

    const data = new FormData();
    data.append('type', 'get_map_users');
    data.append('user_id', userToken);

    if (filterData && Object.keys(filterData).length > 0) {
      if (filterData.gender && filterData.gender !== 'all') {
        data.append('gender', filterData.gender);
      }
      if (filterData.interests && filterData.interests.length > 0) {
        data.append('interests', JSON.stringify(filterData.interests));
      }
      if (filterData.languages && filterData.languages.length > 0) {
        const languageNames = filterData.languages.map(lang => lang.name);
        data.append('languages', JSON.stringify(languageNames));
      }
    }

    try {
      const res = await Promise.race([
        postRef.current('', data),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('API timeout')), 10000)
        )
      ]);

      if (res?.result) {
        setUsers(prevUsers => {
          const newUsers = res.data;
          if (JSON.stringify(prevUsers) !== JSON.stringify(newUsers)) {
            return newUsers;
          }
          return prevUsers;
        });
      } else {
        setUsers([]);
      }
    } catch (err) {
      console.log("Error in mapUsers API =>", err, 'at', new Date().toLocaleTimeString());
    } finally {
      setIsUsersLoading(false);
    }
  }, [userToken, filterData]);

  // Interval management
  useEffect(() => {
    if (!userToken) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    getMapUsers();

    intervalRef.current = setInterval(() => {
      getMapUsers();
    }, 10000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [userToken, filterData, getMapUsers]);

  // Cleanup interval on unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  // When filterData changes, call API immediately
  useEffect(() => {
    if (userToken && filterData !== null) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      getMapUsers();

      intervalRef.current = setInterval(() => {
        getMapUsers();
      }, 10000);
    }
  }, [filterData, userToken, getMapUsers]);

  // Update user location when lat/lng changes
  useEffect(() => {
    console.log("the user latitude is", latitude);
    console.log("the user userToken is", userToken);
    console.log("the user longitude is", longitude);
    console.log("the user useDefaultLocation is", useDefaultLocation);
    const updateUserLocation = async () => {
      if (!latitude || !longitude || !userToken) return;

      const data = new FormData();
      data.append('type', 'add_data');
      data.append('user_id', userToken);
      data.append('table_name', 'user_locations');
      data.append('lat', latitude);
      data.append('lng', longitude);

      try {
        await postRef.current('', data);
      } catch (err) {
        console.log("Error updating location =>", err);
      }
    };

    const timeoutId = setTimeout(() => {
      if (latitude && longitude && !useDefaultLocation) {
        updateUserLocation();
      }
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [latitude, longitude, userToken, useDefaultLocation]);

  // Helper functions for markers
  const convertImageToDataURL = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';

      const timeout = setTimeout(() => {
        console.error('Image load timeout for:', url);
        reject(new Error('Image load timeout'));
      }, 10000);

      img.onload = () => {
        clearTimeout(timeout);

        // Create square canvas based on image dimensions
        const size = 200; // Fixed size for consistency
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');

        // Calculate scale to cover the entire canvas (like object-fit: cover)
        const scale = Math.max(size / img.width, size / img.height);
        const scaledWidth = img.width * scale;
        const scaledHeight = img.height * scale;

        // Center the image
        const x = (size - scaledWidth) / 2;
        const y = (size - scaledHeight) / 2;

        // Fill background color
        ctx.fillStyle = MARKER.avatar();
        ctx.fillRect(0, 0, size, size);

        // Draw image with cover fit
        ctx.drawImage(img, x, y, scaledWidth, scaledHeight);

        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = (error) => {
        console.error('Image failed to load:', url, error);
        clearTimeout(timeout);
        reject(error);
      };

      img.src = url;
    });
  };

  const createMarkerWithBorder = async (imageUrl) => {
    try {
      const imageDataUrl = await convertImageToDataURL(imageUrl);
      const avatarSize = 44;
      const borderSize = 3; // white ring
      const shadowPad = 6;
      const contentSize = avatarSize + borderSize * 2;
      const totalSize = contentSize + shadowPad * 2;
      const cx = totalSize / 2;
      const cy = totalSize / 2;

      const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="${totalSize}" height="${totalSize}">
  <defs>
    <filter id="markerShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
      <feOffset dx="0" dy="1.5" result="offsetblur"/>
      <feComponentTransfer>
        <feFuncA type="linear" slope="0.2"/>
      </feComponentTransfer>
      <feMerge>
        <feMergeNode/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
    <clipPath id="avatarClip">
      <circle cx="${avatarSize / 2}" cy="${avatarSize / 2}" r="${avatarSize / 2}" />
    </clipPath>
  </defs>
  <!-- White ring + light shadow (self marker) -->
  <circle cx="${cx}" cy="${cy}" r="${contentSize / 2}" fill="${MARKER.white()}" filter="url(#markerShadow)" />
  <g transform="translate(${shadowPad + borderSize}, ${shadowPad + borderSize})">
    <circle cx="${avatarSize / 2}" cy="${avatarSize / 2}" r="${avatarSize / 2}" fill="${MARKER.fallback()}" />
    <image href="${imageDataUrl}" x="0" y="0" width="${avatarSize}" height="${avatarSize}" clip-path="url(#avatarClip)" preserveAspectRatio="xMidYMid slice" />
  </g>
</svg>`;

      return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    } catch (error) {
      // CORS canvas often fails for LinkedIn CDNs — return absolute URL so MarkerF can load it directly
      console.warn('Canvas marker failed (likely CORS); using remote image URL:', error);
      return imageUrl || null;
    }
  };

  const onMapLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  // Show loading state while the map is loading
  if (!isLoaded) {
    return <Splash />;
  }

  return (
    <>
      <LocationPermissionModal
        show={showLocationModal}
        loading={locationLoading}
        permissionStatus={permissionStatus}
        error={locationError}
        onRetry={handleLocationRetry}
        onCancel={handleUseWithoutLocation}
      />

      <StackedUsersModal
        show={stackedUsersModal.show}
        users={stackedUsersModal.users}
        onClose={handleCloseStackedModal}
        onUserSelect={handleUserSelectFromModal}
      />

      <div className="map-container h_100vh">
        <div className="location-header">
          <div>
            <h3 className='britti_medium fs_16'>
              {showUserAtCurrentLocation ? "Current Location" : checkInStatus ? "Check-in Location" : "Current Location"}
            </h3>
            <p className='flex items-center gap-[6px] txt_grey fs_14 '>
              <RiMapPinLine />
              <span className='max-w-[300px] text-clamp-1 mt-[3px]'>
                {checkInStatus && !showUserAtCurrentLocation
                  ? (reduxCheckIn?.place_name
                      || reduxCheckIn?.location?.name
                      || localStorage.getItem('checkInPlaceName')
                      || currentAddress)
                  : currentAddress}
              </span>
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button className='equalizerBTN' onClick={handleFilterShow}>
              <RiEqualizer2Line className='w-[16px] text-[var(--primary)]' />
            </button>
            <Link to='/notification' className='equalizerBTN relative'>
              <RiNotification3Line className='w-[20px] text-[var(--primary)]' />
              {showNotification ? (
                <span className='Ellipse' style={{ top: '8px', left: '21px', height: '16px', width: '16px' }}></span>
              ) : null}
            </Link>
          </div>
        </div>

        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          zoom={checkInStatus && !showUserAtCurrentLocation ? 16 : 14}
          onLoad={onMapLoad}
          options={{
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: false,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            keyboardShortcuts: true,
            cameraControl: false,
            gestureHandling: 'cooperative',
            clickableIcons: false,
            styles: [
              { featureType: 'poi', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.attraction', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.place_of_worship', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.school', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.sports_complex', stylers: [{ visibility: 'off' }] },
              { featureType: 'transit', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            ],
          }}
        >

          {/* GPS Blue Dot - Show ONLY if user is NOT checked in at same location */}
          {(() => {
            if (useDefaultLocation || !location?.latitude || !location?.longitude) {
              return null;
            }

            // If checked in and coordinates are same, don't show blue dot
            if (checkInStatus && checkInLat && checkInLong) {
              const isSameLocation = areCoordinatesSame(
                location.latitude,
                location.longitude,
                checkInLat,
                checkInLong
              );

              if (isSameLocation) {
                return null; // Don't show blue dot
              }

            }

            // Show blue dot if not checked in OR checked in at different location
            return (

              <MarkerF
                position={{ lat: location?.latitude, lng: location?.longitude }}
                icon={{
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 12,
                  fillColor: MARKER.primary(),
                  fillOpacity: 1,
                  strokeColor: MARKER.white(),
                  strokeWeight: 3,
                }}
                title="Your Current Location"
                zIndex={999}
              />
            );
          })()}

          {/* Current User's Check-in Marker - Show ONLY if checked in AND NOT in any stack */}
          {(() => {
            const checkInLat = localStorage.getItem('checkInLat');
            const checkInLong = localStorage.getItem('checkInLong');

            if (!checkInStatus || !checkInLat || !checkInLong) {
              return null;
            }
            const selfIconUrl = currentUserIcon || createDefaultUserIcon();

            // Check if current user is in any group with other users
            const userInStack = groupedUsers.some(group => {
              const hasCurrentUser = group?.users?.some(u => u.isCurrentUser);
              const hasOtherUsers = group?.users?.some(u => !u.isCurrentUser);
              return hasCurrentUser && hasOtherUsers;
            });

            // Only show separate marker if user is NOT in any stack
            if (userInStack) {
              return null;
            }

            return (
              <MarkerF
                position={{
                  lat: parseFloat(checkInLat),
                  lng: parseFloat(checkInLong)
                }}
                icon={{
                  url: selfIconUrl,
                  scaledSize: new google.maps.Size(56, 56),
                  anchor: new google.maps.Point(28, 28),
                }}
                zIndex={1001}
                title="Your Check-in Location"
              />
            );
          })()}

          {/* All Users - Grouped/Stacked markers */}
          {groupedUsers?.map((group) => {
            if (!userIcons[group.id]) return null;

            const hasCurrentUser = group.users.some(u => u.isCurrentUser);
            const hasOtherUsers = group.users.some(u => !u.isCurrentUser);

            // If this group has ONLY current user and no others, skip
            if (hasCurrentUser && !hasOtherUsers) {
              return null;
            }

            // Calculate width based on actual user count - matching reference design
            let width, height;
            const userCount = group.count;

            if (userCount === 1) {
              width = 60;
              height = 60;
            } else if (userCount === 2) {
              width = 82;
              height = 60;
            } else if (userCount === 3) {
              width = 104;
              height = 60;
            } else {
              width = 126;
              height = 60;
            }

            const anchorX = width / 2;
            const anchorY = height / 2;

            return (
              <MarkerF
                key={group.id}
                position={{ lat: group.lat, lng: group.lng }}
                onClick={() => handleStackedMarkerClick(group)}
                icon={{
                  url: userIcons[group.id],
                  scaledSize: new google.maps.Size(width, height),
                  anchor: new google.maps.Point(anchorX, anchorY),
                }}
                zIndex={100}
              />
            );
          })}

        </GoogleMap>
        <div className='footerBackground'></div>
        <FooterHome
          checkoutShow={handleCheckInStatusShow}
          checkInShow={handleCheckInShow}
          navigateToCheckIn={navigateToCheckInFromTimer}
        />
      </div>

      {/* Drawers */}
      <NearbyDrawer
        show={peopleDrawer}
        hide={handlePeopleClose}
        userData={selectedUser}
      />
      <FilterDrawer
        show={filterDrawer}
        hide={handleFilterClose}
        setFilterData={setFilterData}
      />
      <CheckIn
        show={checkInDrawer}
        hide={handleCheckInClose}
        isReplacingCheckIn={isReplacingCheckIn}
      />
      <CheckInManage
        show={checkInStatusDrawer}
        hide={handleCheckInStatusClose}
        checkInShow={handleCheckInShow}
        successDrawer={handleCompleteCheckOutShow}
      />
      <CheckOut
        show={checkOutDrawer}
        hide={handleCheckOutClose}
        successDrawer={handleCompleteCheckOutShow}
      />
      <CheckOutComplete
        show={checkoutComplete}
        checkInShow={handleCheckInShow}
        hide={handleCompleteCheckoutClose}
        placeName={lastCheckoutPlace}
      />
      <VisibilityDrawer />
    </>
  );
};

export default Home;